import { useOrderedBanners } from './orderedBanners';
import type { Banner } from './types';

export function useBanner(): Banner | undefined {
	const banners = useOrderedBanners();
	return banners[0];
}
